<template>
  <div
    class="card"
    style="
      margin: 10px 0;
      background-color: #ffffff99;
      border: 2px solid #ec62ea;
    "
  >
    <div class="card-body" style="background-color: transparent">
      <div class="row">
        <div
          v-if="!onDashboard"
          class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11"
        >
          <p
            style="
              margin: 10px;
              font-family: Ubuntu;
              font-size: 14px;
              font-weight: 900;
              color: #7d0c7e;
            "
          >
            <!-- <i style="margin-right: 10px" class="fas fa-list"></i> -->
            Listado de últimos referidos
          </p>
        </div>
        <div
          v-if="!onDashboard"
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 16px;
        "
      >
        <img
          src="../../assets/img/Xtrim/ingresa-tus-nuevos-referidos-aqui.webp"
          style="width: 100%; max-width: 550px"
        />
        <div
          style="
            position: relative;
            display: flex;
            justify-content: center;
            width: fit-content;
          "
        >
          <img
            src="../../assets/img/Xtrim/manito-izq.png"
            style="position: absolute; top: 0; left: 0"
            class="scaling-image"
          />

          <button
            v-if="onDashboard"
            @click="registerReferral"
            class="pinkPurpleText"
          >
            Ingresar Referido
          </button>
          <img
            src="../../assets/img/Xtrim/manito-der.png"
            style="position: absolute; top: 0; right: 0"
            class="scaling-image"
          />
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="sales"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th data-priority="3">Fecha/Hora</th>
            <th data-priority="1">Referido</th>
            <th>Celular</th>
            <th>Estado</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>

  <!-- Modal Notes History -->
  <ModalNotesHistory
    v-if="showNotesModal"
    :key="componentKeyModalNotesHistory"
    :notes="selectedNotes"
    :referral-name="selectedReferralName"
    @closed="closeNotesModal"
    ref="notesHistoryModal"
  />
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import ModalCompletarVenta from "./ModalCompletarVenta.vue";
import ModalNotesHistory from "./ModalNotesHistory.vue";
import $ from "jquery";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    ModalCompletarVenta,
    ModalNotesHistory,
  },
  props: ["userId", "tokenAuth", "onDashboard", "registerReferral"],
  data() {
    return {
      loading: true,
      sales: [],
      componentKeyModalCompletarVenta: 100,
      componentKeyModalNotesHistory: 200,
      idVenta: "",
      showModal: false,
      showNotesModal: false,
      selectedNotes: [],
      selectedReferralName: "",
      columns: [
        { data: "dateFormatted", width: "20%" },
        {
          data: null,
          width: "30%",
          render: (data) => {
            const hasNotes = data.notes?.length > 0;
            const notesText = hasNotes
              ? data.notes[data.notes.length - 1].note
              : "";
            const notesPreview =
              notesText.length > 50
                ? notesText.substring(0, 50) + "..."
                : notesText;

            return `${data.displayName}  ${
              hasNotes
                ? `<br><b>Nota: </b><span 
                    class="notes-link" 
                    data-referral-id="${data.id || ""}" 
                    data-referral-name="${data.displayName || ""}" 
                    data-notes='${JSON.stringify(data.notes || []).replace(/'/g, "&#39;")}'
                    style="text-decoration: underline; color: #7d0c7e; cursor: pointer; font-weight: 600;"
                    title="Clic para ver historial completo de notas">
                    ${notesPreview} 
                    <i class="fas fa-external-link-alt" style="font-size: 0.8em; margin-left: 4px;"></i>
                  </span>`
                : ""
            }`;
          },
        },
        { data: "phone", width: "20%" },
        { data: "status", width: "30%" },
      ],
      options: {
        responsive: true,
        ordering: false,
        lengthMenu: [
          [5, 15, 25, 35, 50, -1],
          [5, 15, 25, 35, 50, "All"],
        ],
        pageLength: 5,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "No tienes referidos ¡Refiere ya!",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  computed: {},
  watch: {
    sales: {
      handler() {
        // Re-setup event listeners when sales data changes
        this.$nextTick(() => {
          this.setupNotesEventListeners();
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.$eventBus.on("reiniciarModalCompletarVenta", () => {
      this.componentKeyModalCompletarVenta += 1;
      this.showModal = false;
    });

    this.getListado();

    // Set up event listener for notes links after component is mounted
    this.$nextTick(() => {
      this.setupNotesEventListeners();
    });
  },
  methods: {
    showNotesHistory(notes, referralName) {
      this.selectedNotes = Array.isArray(notes) ? notes : [];
      this.selectedReferralName = referralName || "Referido";
      this.showNotesModal = true;

      this.$nextTick(() => {
        if (this.$refs.notesHistoryModal) {
          this.$refs.notesHistoryModal.show();
        }
      });
    },

    closeNotesModal() {
      this.showNotesModal = false;
      this.componentKeyModalNotesHistory += 1;
      this.selectedNotes = [];
      this.selectedReferralName = "";
    },

    setupNotesEventListeners() {
      // Remove existing event listeners to prevent duplicates
      $(document).off("click", ".notes-link");

      // Add click event listener for notes links
      $(document).on("click", ".notes-link", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const element = $(event.currentTarget);
        const referralId = element.data("referral-id");
        const referralName = element.data("referral-name");
        let notesData = element.data("notes");

        // Parse the notes data if it's a string
        if (typeof notesData === "string") {
          try {
            notesData = JSON.parse(notesData.replace(/&#39;/g, "'"));
          } catch (e) {
            console.error("Error parsing notes data:", e);
            notesData = [];
          }
        }

        this.showNotesHistory(notesData, referralName);
      });
    },

    refresh() {
      this.$eventBus.emit("reiniciarListadoVentas");
    },

    getListado() {
      this.$https
        .get("/sales/me")
        .then((response) => {
          this.loading = false;

          this.sales = response.data.sales;
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.loading = false;
            return;
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loading = false;

          // this.getListado();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

table thead {
  background-color: #7d0c7e; /* Change to your desired background color */
  color: #ffffff; /* Change font color */
}

/* Optional: Target the <th> elements for more specific styling */
table thead th {
  font-weight: bold; /* Make the text bold */
  padding: 10px; /* Adjust padding for better spacing */
  text-align: left; /* Align text if needed */
}

/* If you want to style a specific table */
table.dataTable thead th {
  background-color: #7d0c7e; /* Specific background color for this table */
  color: white; /* Specific font color */
}

:deep(table tbody tr td) {
  font-weight: bold !important;
}

:deep(.form-control.form-control-sm) {
  border: 2px solid #f9cc03;
  background: white;
}

:deep(.dataTables_filter label) {
  color: #7d0c7e;
}

:deep(.dataTables_length label) {
  color: #7d0c7e;
}
:deep(.dataTables_length label select) {
  border: 2px solid #f9cc03;
  background-color: white;
}

:deep(.dataTables_length) {
  display: none;
}

:deep(.dataTables_filter) {
  display: none;
}

/* Notes link styling */
:deep(.notes-link) {
  position: relative;
  display: inline-block;
  transition: all 0.3s ease !important;
  text-decoration: underline !important;
  color: #7d0c7e !important;
}

:deep(.notes-link:hover) {
  color: #a532bd !important;
  text-decoration: underline !important;
  transform: translateY(-1px);
  text-shadow: 0 1px 2px rgba(125, 12, 126, 0.2);
}

/* Remove the duplicate underline effect */
:deep(.notes-link::after) {
  display: none;
}

/* Enhance table row interactions */
:deep(table tbody tr:hover) {
  background-color: rgba(125, 12, 126, 0.05) !important;
  transform: scale(1.01);
  transition: all 0.2s ease;
}

.pinkPurpleText {
  padding: 5px 10px;
  background: rgb(170, 50, 189);
  background: linear-gradient(
    68deg,
    rgba(170, 50, 189, 1) 0%,
    rgb(226, 80, 232) 100%
  );
  border: 2px solid #ec62ea;
  color: white;
  font-family: Ubuntu;
  margin: 0;
  width: max-content;
  border-radius: 16px;
  gap: 8px;
  margin-top: 8px;
  font-weight: 900;
  margin-left: 70px;
  margin-right: 70px;
  box-shadow: 0px 2px 10px 2px #bc49be48;
}

.pinkPurpleText:hover {
  background: linear-gradient(
    68deg,
    rgb(226, 80, 232) 0%,
    rgba(170, 50, 189, 1) 100%
  );
}
@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.scaling-image {
  max-height: 34px;
  animation: scaleAnimation 1.5s ease-in-out infinite;
}
</style>
